<template>
  <div
    class="message"
    :style="`border-color: ${tintColor}`"
    :data-message-type="ofType"
  >
    <div class="message__header">
      <component :is="headerIcon" :fill="tintColor" class="message__icon" />
    </div>
    <div class="message__content">
      <p class="message__message">{{ message }}</p>
    </div>
    <div class="message__footer">
      <button
        class="message__dismiss-btn"
        :style="`border-color: ${tintColor}`"
        @click="handleDismiss"
      >
        Dismiss
      </button>
    </div>
    <div class="message__timer-wrapper">
      <p
        class="message__timer"
        :style="`background: ${tintColor}; width: ${timeToDismiss}%`"
      ></p>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  toRefs,
  ref,
  computed,
  onBeforeMount,
  onBeforeUnmount,
} from '@vue/composition-api'
import ErrorIcon from '@/assets/icons/subscriptions/alert-triangle.svg'
import AlertIcon from '@/assets/icons/notification.svg'
import SuccessIcon from '@/assets/icons/progress/course-progress-icon.svg'

export default defineComponent({
  name: 'Message',
  components: {
    ErrorIcon: { ...ErrorIcon, name: 'ErrorIcon' },
    AlertIcon: { ...AlertIcon, name: 'AlertIcon' },
    SuccessIcon: { ...SuccessIcon, name: 'SuccessIcon' },
  },
  props: {
    message: {
      type: String,
      required: true,
    },
    ofType: {
      // error, notification, success
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { message, ofType } = toRefs(props)
    const interval = ref(null)
    const timeToDismiss = ref(100)

    const headerIcon = computed(() => {
      if (ofType.value === 'notification') {
        return AlertIcon
      }
      if (ofType.value === 'error') {
        return ErrorIcon
      }
      return SuccessIcon
    })

    const tintColor = computed(() => {
      if (ofType.value === 'notification') {
        return 'var(--blue)'
      }
      if (ofType.value === 'error') {
        return 'var(--red)'
      }
      return 'var(--green)'
    })

    const handleDismiss = () => emit('dismiss-message', message.value)

    onBeforeMount(() => {
      interval.value = setInterval(() => {
        timeToDismiss.value -= 15
        if (timeToDismiss.value <= 0) {
          handleDismiss()
        }
      }, 1000)
    })

    onBeforeUnmount(() => clearInterval(interval.value))

    return {
      interval,
      timeToDismiss,
      headerIcon,
      tintColor,
      handleDismiss,
    }
  },
})
</script>

<style lang="scss" scoped>
.message {
  box-shadow: var(--notification-box-shadow);
  background: var(--white);
  border: 3px solid;
  height: auto;
  border-radius: 15px;
  margin: 0 0 5px 0;
  @include mobile {
    min-width: 400px;
  }
  &__header {
    display: flex;
    justify-content: center;
    padding: 15px 0;
    margin: 0 50px;
    border-bottom: 1px solid var(--lighter-gray);
  }
  &__icon {
    height: 35px;
    width: 35px;
  }
  &__content {
    display: flex;
    justify-content: center;
    padding: 10px 25px;
  }
  &__message {
    font-family: var(--font-bold);
    font-size: rem(17);
    color: var(--black);
    max-width: 400px;
  }
  &__footer {
    padding: 10px 0 15px 0;
    display: flex;
    justify-content: center;
  }
  &__dismiss-btn {
    border: 1px solid;
    border-radius: 15px;
    background: transparent;
    padding: 5px 20px;
    text-transform: uppercase;
    font-size: rem(12);
    color: var(--dark-gray);
    cursor: pointer;
    &:hover {
      background: var(--dark-gray);
      color: var(--white);
    }
  }
  &__timer-wrapper {
    width: 99.5%;
    height: 5px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }
  &__timer {
    height: 5px;
    border-bottom-left-radius: 15px;
    transition: 1s ease all;
  }
}
</style>
